import { CALL_API } from '../middleware/api';
import {
  ADMIN_USER_TEAM_SUCCESS,
  USER_LIST_LOADING,
  USER_LIST_SUCCESS,
  ADMIN_LIST_LOADING,
  ADMIN_LIST_PAGE_CHANGE,
  ADMIN_LIST_SEARCH_TEXT,
  ADMIN_LIST_SEARCHING,
  ADMIN_LIST_CLEARING,
} from 'store/constants/userList';

import { getCookieData } from 'utils/cookieHandler';

let cookieName = process.env.REACT_APP_COOKIE_NAME;
let access_token = getCookieData(cookieName);

const header = {
  Authorization: `Bearer ${access_token}`,
  Accept: 'application/json',
};

export const getUserList = (userNames = '') => {
  const authURL =
    process.env.REACT_APP_LUMS_AUTH_URL ||
    (window._env_ && window._env_.REACT_APP_LUMS_AUTH_URL);
  let endpoint = `${authURL}/api/users/basic-info`;

  const params = {
    allUsers: true,
    includeServiceAccounts: true,
  };

  if (userNames) {
    params.usernames = userNames;
  }

  return {
    [CALL_API]: {
      types: [USER_LIST_LOADING, USER_LIST_SUCCESS],
      endpoint: endpoint,
      method: 'GET',
      appendBaseUrl: false,
      query: params,
      type: 'json',
      headers: header,
    },
  };
};
let associatedTestsController;
export const getAdminTeams = ({
  search = '',
  page = 1,
  limit = 20,
  isLoadMore = false,
  clearAll = false,
} = {}) => {
  const authURL =
    process.env.REACT_APP_LUMS_AUTH_URL ||
    (window._env_ && window._env_.REACT_APP_LUMS_AUTH_URL);
  let endpoint = `${authURL}/api/organization/teams?limit=${limit}&page=${page}&searchTxt=${encodeURIComponent(
    search
  )}`;
  if (associatedTestsController) {
    associatedTestsController.abort();
  }
  associatedTestsController = new AbortController();
  return {
    [CALL_API]: {
      types: [ADMIN_LIST_LOADING, ADMIN_USER_TEAM_SUCCESS],
      endpoint: endpoint,
      method: 'GET',
      appendBaseUrl: false,
      signal: associatedTestsController.signal,
      type: 'json',
      headers: header,
      extra: { isLoadMore, clearAll },
    },
  };
};

export const updateAdminTeamListPage = (currentPage) => {
  return {
    type: ADMIN_LIST_PAGE_CHANGE,
    payload: currentPage,
  };
};

export const adminTeamSearchText = (searchText) => {
  return {
    type: ADMIN_LIST_SEARCH_TEXT,
    payload: searchText,
  };
};

export const adminTeamSearching = () => {
  return {
    type: ADMIN_LIST_SEARCHING,
  };
};

export const adminTeamClearing = () => {
  return {
    type: ADMIN_LIST_CLEARING,
  };
};

export default getUserList;
